/**
 * Client env (Vite). Only `VITE_*` keys are inlined at build time.
 * Server secrets must never use the VITE_ prefix.
 */

function trimEnv(value: string | undefined): string {
  return typeof value === 'string' ? value.trim() : '';
}

/** Deploy base path without trailing slash ('' when app is served at `/`). */
export function getPublicBase(): string {
  return (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
}

export function readSupabaseUrl(): string {
  return trimEnv(import.meta.env.VITE_SUPABASE_URL);
}

export function readSupabasePublishable(): string {
  return (
    trimEnv(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) ||
    trimEnv(import.meta.env.VITE_SUPABASE_ANON_KEY)
  );
}

export function readSiteUrl(): string {
  return trimEnv(import.meta.env.VITE_SITE_URL);
}

export function readServerUrl(): string {
  return trimEnv(import.meta.env.VITE_SERVER_URL) || readSiteUrl();
}

export function readOpsSiteUrl(): string {
  return trimEnv(import.meta.env.VITE_OPS_SITE_URL);
}

export function readApiUrl(): string {
  return trimEnv(import.meta.env.VITE_API_URL) || '/api';
}

export function isMswEnabled(): boolean {
  return import.meta.env.VITE_USE_MSW === 'true';
}

export function isDemoModeEnabled(): boolean {
  return import.meta.env.VITE_DEMO_MODE === 'true' || isMswEnabled();
}

export function readGa4MeasurementId(): string {
  return trimEnv(import.meta.env.VITE_GA4_MEASUREMENT_ID);
}
